var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("Zahlungsmethode für zukünftige Bestellungen speichern")]),_c('div',[_vm._v("Email-Adresse: "+_vm._s(_vm.customer))]),_c('b-button',{attrs:{"disabled":_vm.inProgress},on:{"click":_vm.redirectToStripe}},[_vm._v("Zahlungsmethode auf Stripe hinterlegen")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }